import { connect } from 'react-redux';
import TooltipRenderer from './TooltipRenderer';
import mapDispatchToProps from './mapDispatchToProps';

const connectedTooltipRenderer = connect(undefined, mapDispatchToProps)(TooltipRenderer);

export default connectedTooltipRenderer;
